function initializeResultListModel() {
	var customBranchTexts = {};

	window.ResultListModelBase = Backbone.Model.extend({
		qrCodeEnabled: false,
		vCardEnabled: false,

		initialize: function () {
			if (!this.vCardEnabled) {
				this.qrCodeEnabled = false;
			}
		},

		addCustomBranchText: function (branchCode, text) {
			customBranchTexts[branchCode] = text;
		},

		removeCustomBranchText: function (branchCode) {
			delete customBranchTexts[branchCode];
		},

		_convertDataToObj: function ($el, type) {
			var obj = {},
				dataAttr = 'data-' + type;
			$el.each(function (i, n) {
				var name = $(n).attr(dataAttr);
				obj[name.substring(0, 1).toUpperCase() + name.substring(1)] = $(n).text();
			});
			return obj;
		},

		createVCard: function (addressItems) {
			var vcards = [];
			_.each(addressItems, function (addressItem) {
				addressItem.VCard =
					'BEGIN:VCARD\n' +
					'VERSION:2.1\n' +
					'FN:' +
					addressItem.GeneratedData.Title +
					'\n' +
					'N:' +
					addressItem.GeneratedData.Title +
					';\n' +
					'ADR;HOME:;;' +
					addressItem.GeneratedData.Street +
					';' +
					addressItem.GeneratedData.City +
					';;' +
					addressItem.BasicData.Address.Zip +
					';Deutschland\n' +
					(addressItem.BasicData.Contact.Fax
						? 'TEL;HOME;FAX:' + addressItem.BasicData.Contact.Fax + '\n'
						: '') +
					(addressItem.BasicData.Contact.Phone
						? 'TEL;HOME;VOICE:' + addressItem.BasicData.Contact.Phone + '\n'
						: '') +
					(addressItem.BasicData.Contact.Mobile
						? 'TEL;HOME;CELL:' + addressItem.BasicData.Contact.Mobile + '\n'
						: '') +
					(addressItem.BasicData.Contact.Email
						? 'EMAIL;INTERNET:' + addressItem.BasicData.Contact.Email + '\n'
						: '') +
					(addressItem.BasicData.Contact.Url ? 'URL;WORK:' + addressItem.BasicData.Contact.Url + '\n' : '') +
					'END:VCARD\n';
				vcards.push(addressItem.VCard);
			});
		},

		createQRCode: function (addressItems) {
			var vCards = _.map(addressItems, function (addressItem) {
				return addressItem.VCard;
			});
			$.ajax({
				async: false,
				url: '/api_js/v2/HelperUtils.asmx/QRCodeSpecialCharacters',
				data: {
					SystemPartner: ym.BaseValues.Partner,
					SecurityID: ym.BaseValues.SecurityID,
					Channel: ym.BaseValues.Channel,
					QRCodeValue: JSON.stringify(vCards),
					ReplaceSpecialCharacters: 'false'
				},

				dataType: 'json',
				type: 'post',
				success: function (qrcodes) {
					if (qrcodes.Values && qrcodes.Values.length > 0) {
						_.each(qrcodes.Values, function (qrcode, index) {
							addressItems[index].QRCode = qrcode;
						});
					}
				}
			});
		},

		createGeneratedData: function (addressItem) {
			// Standardinformationen aufbereiten
			var generatedData = {
				Title: $.trim(addressItem.BasicData.Title),
				Zip: $.trim(addressItem.BasicData.Address.Zip),
				City: $.trim(addressItem.BasicData.Address.City),
				Street: $.trim(addressItem.BasicData.Address.Street),
				HouseNo: $.trim(addressItem.BasicData.Address.HouseNo),
				Country: $.trim(addressItem.BasicData.Address.Country)
			};

			if (generatedData.Title == '') {
				generatedData.Title = $.trim(addressItem.BasicData.Address.CompanyName);
			}

			// Selbstdefinierte Texte zu den BranchenCodes
			generatedData.CustomBranchTexts = [];
			_.each(addressItem.BasicData.BranchListElements, function (branchElement) {
				// IE don't like undefined!
				try {
					if (customBranchTexts && customBranchTexts[branchElement.BranchCode]) {
						generatedData.CustomBranchTexts.push(customBranchTexts[branchElement.BranchCode]);
					}
				} catch (e) {
					console.error(e);
				}
			});

			generatedData.Icon = new ym.common.CIcon(
				'/presentation/filialfinder/content/img/icons/PinDefault.png',
				{
					Width: 37,
					Height: 44
				},
				{ X: 29, Y: 32 }
			);
			generatedData.IconHighlight = new ym.common.CIcon(
				'/presentation/filialfinder/content/img/icons/PinDefault.png',
				{
					Width: 37,
					Height: 44
				},
				{ X: 29, Y: 32 }
			);

			return generatedData;
		},

		createGeneratedShadowData: function (addressItem, self) {
			// Standardinformationen aufbereiten
			var generatedData = {
				Title: $.trim(addressItem.BasicData.Title),
				Zip: $.trim(addressItem.BasicData.Address.Zip),
				City: $.trim(addressItem.BasicData.Address.City),
				Street: $.trim(addressItem.BasicData.Address.Street),
				HouseNo: $.trim(addressItem.BasicData.Address.HouseNo),
				Country: $.trim(addressItem.BasicData.Address.Country)
			};

			if (generatedData.Title == '') {
				generatedData.Title = $.trim(addressItem.BasicData.Address.CompanyName);
			}

			// Selbstdefinierte Texte zu den BranchenCodes
			generatedData.CustomBranchTexts = [];
			_.each(addressItem.BasicData.BranchListElements, function (branchElement, i) {
				// IE don't like undefined!
				try {
					if (customBranchTexts && customBranchTexts[branchElement.BranchCode]) {
						generatedData.CustomBranchTexts.push(customBranchTexts[branchElement.BranchCode]);
					}
				} catch (e) {
					console.error(e);
				}
			});

			generatedData.Icon = new ym.common.CIcon(
				'/presentation/filialfinder/content/img/icons/PinDefault.png',
				{
					Width: 17,
					Height: 20
				},
				{ X: 29, Y: 32 }
			);
			generatedData.IconHighlight = new ym.common.CIcon(
				'/presentation/filialfinder/content/img/icons/PinDefault.png',
				{
					Width: 17,
					Height: 20
				},
				{ X: 29, Y: 32 }
			);

			return generatedData;
		},

		createGeneratedClusterData: function (addressItem, self) {
			// Standardinformationen aufbereiten
			var generatedData = {};

			generatedData.Icon = new ym.common.CIcon(
				'/presentation/filialfinder/content/img/icons/cluster-icon-' + Math.min(addressItem.Count, 99) + '.png',
				{
					Width: 56,
					Height: 53
				},
				{ X: 21, Y: 35 }
			);
			generatedData.IconHighlight = new ym.common.CIcon(
				'/presentation/filialfinder/content/img/icons/cluster-icon-' + Math.min(addressItem.Count, 99) + '.png',
				{
					Width: 56,
					Height: 53
				},
				{ X: 21, Y: 35 }
			);

			return generatedData;
		},

		_convertMemoItems: function (memoItems) {
			if (!memoItems || memoItems.length == 0) return [];

			_.each(memoItems, function (item) {
				if (item.Type === 'OPENING_HOURS' && item.OpeningHoursMask === 'NONE') {
					// Öffnungszeiten werden vorformatiert im Model (quick & dirty)
					var week = item.Text.split(/\<br\s*\/\>|\&lt;br\s*\/\&gt;/g);
					var openingHours = '<div class="container-fluid openinghours">';
					_.each(week, function (weekDay) {
						var day = weekDay.split(': ');
						if (day.length > 1) {
							var dayParts = day[1].split(' ');
							if (dayParts.length > 1) {
								openingHours +=
									'<div class="row-fluid"><b class="span4">{0}</b><div class="span8"><span style="margin-right: 20px;">{1}</span><span>{2}</span></div></div>'
										.replace('{0}', day[0])
										.replace('{1}', dayParts[0])
										.replace('{2}', dayParts[1]);
							} else {
								openingHours +=
									'<div class="row-fluid"><b class="span4">{0}</b><div class="span8"><span>{1}</span></div></div>'
										.replace('{0}', day[0])
										.replace('{1}', day[1]);
							}
						}
					});
					openingHours += '</div>';
					item.Text = openingHours;
				}
			});

			return _.sortBy(memoItems, function (item) {
				return item.BlockNo;
			});
		},

		fromHTML: function (html) {
			var self = this;
			var addressItems = self.get('AddressItems');
			addressItems.splice(0, addressItems.length);
			$(html).each(function (i, n) {
				var id = $(n).attr('data-id'),
					providerId = $(n).attr('data-provider-id'),
					providerFk = $(n).attr('data-provider-fk'),
					$address = $(n).find('[data-address]'),
					$contact = $(n).find('[data-contact]');

				var branchListElements = $.parseJSON(($(n).attr('data-branches') || '{}').replace(/&quot;/g, '"'));
				var objectListItems = $.parseJSON(($(n).attr('data-objectlist') || '{}').replace(/&quot;/g, '"'));
				var memoData = $.parseJSON(($(n).attr('data-memoitems') || '{}').replace(/&quot;/g, '"'));

				var addressItem = {
					BasicData: {
						Identifiers: {
							YMID: id,
							YMID3: id,
							YMIDUrlEncoded: id,
							YMIDPathEncoded: id,
							ProviderID: providerId,
							ProviderForeignKey: providerFk
						},
						Title: $(n).attr('data-title'),
						MemoItems: self._convertMemoItems(memoData || '[]'),
						BranchListElements: branchListElements || [],
						ObjectListItems: objectListItems || [],
						Address: self._convertDataToObj($address, 'address'),
						Contact: self._convertDataToObj($contact, 'contact'),
						Geo: {
							XCoord: $(n).attr('data-x'),
							YCoord: $(n).attr('data-y'),
							Distance: $(n).attr('data-distance')
						}
					}
				};

				addressItem.QRCode = '';
				addressItem.GeneratedData = self.createGeneratedData(addressItem, self);
				addressItems.push(addressItem);
			});

			self.vCardEnabled && self.createVCard(addressItems);
			self.qrCodeEnabled && self.createQRCode(addressItems);

			self.set('AddressItems', addressItems);
			return this;
		},

		fromJSON: function (json) {
			var self = this;

			var addressItems = self.get('AddressItems');
			addressItems.splice(0, addressItems.length);

			json.AddressItems = json.AddressItems || [];

			$.each(json.AddressItems, function (i, addressItem) {
				addressItem.QRCode = '';
				addressItem.GeneratedData = self.createGeneratedData(addressItem, self);
				addressItem.BasicData.MemoItems = self._convertMemoItems(addressItem.BasicData.MemoItems);
				addressItems.push(addressItem);
			});

			var addressShadowItems = self.get('AddressShadowItems');
			addressShadowItems.splice(0, addressShadowItems.length);

			json.AddressShadowItems = json.AddressShadowItems || [];

			$.each(json.AddressShadowItems, function (i, addressItem) {
				addressItem.QRCode = '';
				addressItem.GeneratedData = self.createGeneratedShadowData(addressItem, self);
				addressItem.BasicData.MemoItems = self._convertMemoItems(addressItem.BasicData.MemoItems);
				addressShadowItems.push(addressItem);
			});

			var addressTiles = self.get('AddressTiles');
			addressTiles.splice(0, addressTiles.length);

			json.AddressTiles = json.AddressTiles || [];

			$.each(json.AddressTiles, function (i, addressItem) {
				addressItem.QRCode = '';
				addressItem.GeneratedData = self.createGeneratedClusterData(addressItem, self);
				addressTiles.push(addressItem);
			});

			if (addressItems.length > 0) {
				self.vCardEnabled && self.createVCard(addressItems);
				self.qrCodeEnabled && self.createQRCode(addressItems);
			}

			if (addressShadowItems.length > 0) {
				self.vCardEnabled && self.createVCard(addressShadowItems);
				self.qrCodeEnabled && self.createQRCode(addressShadowItems);
			}

			self.set('AddressItems', addressItems);
			self.set('AddressShadowItems', addressShadowItems);
			self.set('AddressTiles', addressTiles);

			self.set('Paging', json.Paging);
			self.set('SearchData', json.SearchData);
			return this;
		},

		defaults: {
			TitlePrefix: '',
			AddressItems: [],
			AddressShadowItems: [],
			AddressTiles: [],
			SearchData: {}
		}
	});

	window.ResultListModel = ResultListModelBase.extend({
		setQRCode: function (element) {
			var AddressItems = this.get('AddressItems');
			$(element).attr('src', 'data:image/png;base64,' + AddressItems[0].QRCode);
		},

		createGeneratedData: function (AddressItem, self) {
			// Standardinformationen aufbereiten
			var GeneratedData = {
				Title: '',
				City: $.trim(AddressItem.BasicData.Address.City),
				Street: $.trim(AddressItem.BasicData.Address.Street)
			};

			if ($.trim(AddressItem.BasicData.Address.CompanyName) != '') {
				GeneratedData.Title = $.trim(AddressItem.BasicData.Address.CompanyName);
			}

			if ($.trim(AddressItem.BasicData.Address.CompanyNameAddon1) !== '') {
				if (GeneratedData.Title !== '') GeneratedData.Title += ' ';

				GeneratedData.Title += $.trim(AddressItem.BasicData.Address.CompanyNameAddon1);
			}
			if ($.trim(AddressItem.BasicData.Address.CompanyNameAddon2) !== '') {
				if (GeneratedData.Title !== '') GeneratedData.Title += ' ';

				GeneratedData.Title += $.trim(AddressItem.BasicData.Address.CompanyNameAddon2);
			}

			if ($.trim(AddressItem.BasicData.Title) != '') {
				if (GeneratedData.Title != '') GeneratedData.Title += ' ';

				GeneratedData.Title += $.trim(AddressItem.BasicData.Title);
			}

			if (AddressItem.BasicData.MemoItems.length > 0 && document.cookie.indexOf('intern') >= 0) {
				var jsonInfo = _.find(AddressItem.BasicData.MemoItems, function (m) {
					return m.Type === 'JSON_INFO';
				});
				if (jsonInfo) {
					jsonInfo = JSON.parse(jsonInfo.Text);
					if (jsonInfo.HiddenPoiInfos) {
						GeneratedData.Source = jsonInfo.HiddenPoiInfos.Herkunft;
						GeneratedData.SourceDate = jsonInfo.HiddenPoiInfos.Stand;
					}
				}
			}

			// Selbstdefinierte Texte zu den BranchenCodes
			GeneratedData.CustomBranchTexts = [];
			for (var i = 0, l = AddressItem.BasicData.BranchListElements.length; i < l; i++) {
				// IE don't like undefined!
				try {
					GeneratedData.CustomBranchTexts.push(AddressItem.BasicData.BranchListElements[i].BranchCode);
				} catch (e) {}
			}

			GeneratedData.PruefungVorOrt = false;
			_.some(AddressItem.BasicData.BranchListElements, function (e) {
				if (e.BranchText.indexOf('vor Ort') > 0) {
					GeneratedData.PruefungVorOrt = true;
				}
			});

			GeneratedData.CanMakeAppointment = false;
			_.some(AddressItem.BasicData.BranchListElements, function (e) {
				if (e.BranchText.indexOf('Terminvereinbarung') > 0 && AddressItem.BasicData.Contact.Email.indexOf('@') > 0) {
					GeneratedData.CanMakeAppointment = true;
				}
			});
			GeneratedData.AppointmentLink =
				'https://terminanfrage.gtue.de/id/' + AddressItem.BasicData.Identifiers.ProviderForeignKey;

			var icon = this._GetIcon(GeneratedData.CustomBranchTexts, 'D');

			GeneratedData.Icon = icon.IconDefault;
			GeneratedData.IconHighlight = icon.IconHighlight;

			GeneratedData.ShowPruefungVorOrt = !(
				this._hasConfig() &&
				(config.Mode === 'Bau' || config.Mode === 'Anlagensicherheit')
			);

			return GeneratedData;
		},

		createGeneratedShadowData: function (AddressItem, self) {
			var GeneratedData = {};
			GeneratedData.CustomBranchTexts = [];
			for (var i = 0, l = AddressItem.BasicData.BranchListElements.length; i < l; i++) {
				// IE don't like undefined!
				try {
					GeneratedData.CustomBranchTexts.push(AddressItem.BasicData.BranchListElements[i].BranchCode);
				} catch (e) {}
			}

			var icon = this._GetIcon(GeneratedData.CustomBranchTexts, 'D');
			GeneratedData.Icon = icon.IconDefault;
			GeneratedData.IconHighlight = icon.IconHighlight;

			return GeneratedData;
		},

		_Params: [
			{
				BranchType: 'GTUE',
				BC: 'GTUE'.split('|'),
				IconDefault: new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/gtue-logo_60.svg',
					{
						Width: 40,
						Height: 30
					},
					{ X: 20, Y: 15 }
				),
				IconHighlight: new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/gtue-logo_60.svg',
					{
						Width: 40,
						Height: 30
					},
					{ X: 20, Y: 15 }
				)
			},
			{
				BranchType: 'GTUP',
				BC: 'GTUP'.split('|'),
				IconDefault: new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/gtue-logo_60.svg',
					{
						Width: 40,
						Height: 30
					},
					{ X: 29, Y: 32 }
				),
				IconHighlight: new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/gtue-logo_60.svg',
					{
						Width: 40,
						Height: 30
					},
					{ X: 20, Y: 15 }
				)
			},
			{
				BranchType: 'GTUV',
				BC: 'GTUV'.split('|'),
				IconDefault: new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/Gtue_Vertragsanwalt.png',
					{
						Width: 40,
						Height: 40
					},
					{ X: 29, Y: 32 }
				),
				IconHighlight: new ym.common.CIcon(
					'/presentation/filialfinder/areas/gtueMobile/content/img/Gtue_Vertragsanwalt.png',
					{
						Width: 40,
						Height: 40
					},
					{ X: 20, Y: 15 }
				)
			}
		],

		_GetShadowIcon: function () {
			return {};
		},

		_hasConfig: function () {
			return config;
		},

		_GetIcon: function (BranchCodes, Country) {
			if (this._hasConfig() && (config.Mode === 'Bau' || config.Mode === 'Anlagensicherheit')) {
				return this._Params[0];
			}

			var ActiveParamIndex = 0,
				i,
				j,
				BC,
				Param;
			for (i = 0; i < BranchCodes.length; i++) {
				BC = BranchCodes[i];
				for (j = 0; j < this._Params.length; j++) {
					Param = this._Params[j];
					if (_.indexOf(Param.BC, BC) > -1 && j > ActiveParamIndex) {
						ActiveParamIndex = j;
					}
				}
			}

			return this._Params[ActiveParamIndex];
		}
	});
}
